import { TextButton } from '@creditornot/cb-button';
import React, { useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

type InfiniteScrollHelperProps = {
  onFetchMore: () => void;
};

const StyledTextButton = styled(TextButton)`
  align-self: center;
  margin-block: 8px 32px;
`;

const InfiniteScrollHelper = ({ onFetchMore }: InfiniteScrollHelperProps) => {
  const observerTarget = useRef<HTMLDivElement>(null);

  const supportsIntersectionObserver = 'IntersectionObserver' in window;

  useEffect(() => {
    if (!supportsIntersectionObserver) {
      return;
    }

    const target = observerTarget.current;
    const observer = new IntersectionObserver(
      entries => {
        if (entries[0]?.isIntersecting) {
          onFetchMore();
        }
      },
      {
        threshold: 0, // Even a single visible pixel will be enough
      },
    );

    if (target) {
      observer.observe(target);
    }

    return () => {
      if (target) {
        observer.unobserve(target);
      }
    };
  }, [supportsIntersectionObserver, observerTarget, onFetchMore]);

  if (!supportsIntersectionObserver) {
    return (
      <StyledTextButton onClick={() => onFetchMore()}>
        <FormattedMessage id="purchases.show-more" />
      </StyledTextButton>
    );
  }

  return <div ref={observerTarget} />;
};

export default InfiniteScrollHelper;
